import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule, NbUserModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, UsersRoutingModule } from './users-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ProfilRenderComponent } from './profil-render.component';
import { ActiveRenderComponent } from './active-render.component';
import { UsersListComponent } from './userslist.component';
import { EditUserComponent } from './edit-user/edit-user.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    UsersRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
    NbUserModule,
  ],
  entryComponents: [
    UsersListComponent,
    ProfilRenderComponent,
    EditUserComponent,
    ActiveRenderComponent
  ],
  declarations: [
    UsersListComponent,
    ProfilRenderComponent,
    EditUserComponent,
    ActiveRenderComponent,
    ...routedComponents,
  ],
})
export class UsersModule { }
